import React, { useState } from 'react';
import { mockGallery } from '../mockData';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">Work</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            See the quality of our repairs. We take pride in restoring your devices to perfect condition.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {mockGallery.map((item) => (
            <div 
              key={item.id}
              className="group cursor-pointer"
              onClick={() => setSelectedImage(item)}
            >
              <div className="relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
                <div className="grid grid-cols-2 gap-1">
                  <div className="relative aspect-square overflow-hidden">
                    <div className="absolute top-2 left-2 z-10 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                      Before
                    </div>
                    <img 
                      src={item.before}
                      alt={`${item.description} - Before`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="relative aspect-square overflow-hidden">
                    <div className="absolute top-2 right-2 z-10 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                      After
                    </div>
                    <img 
                      src={item.after}
                      alt={`${item.description} - After`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 text-center">
                <h3 className="font-bold text-slate-900 text-lg">{item.description}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-cyan-50 to-blue-50 rounded-3xl p-8 md:p-12 text-center border border-cyan-100 max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
            Quality Guaranteed
          </h3>
          <p className="text-slate-600 text-lg mb-6 max-w-2xl mx-auto">
            We use only high-quality OEM parts and our repairs come with a 90-day warranty. Your satisfaction is our priority.
          </p>
          <button 
            className="btn-primary text-lg px-8 py-4"
            onClick={() => document.getElementById('booking').scrollIntoView({ behavior: 'smooth' })}
          >
            Get Your Repair Today
          </button>
        </div>
      </div>

      {/* Modal for enlarged view */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="max-w-4xl w-full">
            <div className="grid md:grid-cols-2 gap-4">
              <div className="relative">
                <div className="absolute top-4 left-4 bg-red-500 text-white text-sm font-bold px-4 py-2 rounded-full">
                  Before
                </div>
                <img 
                  src={selectedImage.before}
                  alt="Before"
                  className="w-full rounded-2xl"
                />
              </div>
              <div className="relative">
                <div className="absolute top-4 right-4 bg-green-500 text-white text-sm font-bold px-4 py-2 rounded-full">
                  After
                </div>
                <img 
                  src={selectedImage.after}
                  alt="After"
                  className="w-full rounded-2xl"
                />
              </div>
            </div>
            <p className="text-white text-center mt-6 text-xl font-semibold">
              {selectedImage.description}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
